<div *ngIf="!isSinglePageVisible && informativePages?.length === 0">
  <div fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="20px">
    <div>There are no pages yet</div>
    <button mat-raised-button color="accent" (click)="toggleSinglePageVisibility()">
      {{ 'Create the first page' | uppercase }}
    </button>
  </div>
</div>

<div
  class="informative-pages"
  *ngIf="!isSinglePageVisible && informativePages?.length > 0"
  fxLayout="column"
  fxLayoutAlign="start"
  fxLayoutGap="20px"
>
  <div fxLayout="column" fxLayoutGap="20px" *ngIf="infoPages.length">
    <h4 class="informative-pages-title">Informative pages</h4>
    <div fxLayout="column">
      <div
        class="informative-pages-list"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        *ngFor="let page of infoPages"
      >
        <div class="informative-pages-list-item" fxFlex="90" (click)="onSelect(page); toggleSinglePageVisibility()">
          <label class="informative-pages-list-title">
            {{
              (page?.translations | dashboardTranslate: 'title':selectedLanguage?.code)
                ? (page?.translations | dashboardTranslate: 'title':selectedLanguage?.code)
                : 'Untitled page'
            }}</label
          >
        </div>
        <mat-icon
          *ngIf="!page?.isEmail"
          class="informative-pages-list-delete"
          color="primary"
          #tooltip="matTooltip"
          matTooltip="Remove this page"
          matTooltipPosition="above"
          (click)="onDelete(page)"
          >delete
        </mat-icon>
      </div>
    </div>
  </div>
  <mat-divider *ngIf="infoPages.length && thanksPages.length"></mat-divider>
  <div *ngIf="selectedStudy?.type === StudyType.TIIM && thanksPages.length" fxLayout="column" fxLayoutGap="20px">
    <h4 class="informative-pages-title">Thank you pages</h4>
    <div *ngIf="!thanksPages?.length">
      <div>You haven't added any thank you pages yet.</div>
      <div>If you want to add a thank you page, please check 'This is a thank you page' while adding a page.</div>
    </div>
    <div fxLayout="column">
      <div
        class="informative-pages-list"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        *ngFor="let page of thanksPages"
      >
        <div class="informative-pages-list-item" fxFlex="90" (click)="onSelect(page); toggleSinglePageVisibility()">
          <label class="informative-pages-list-title">
            {{
              (page?.translations | dashboardTranslate: 'title':selectedLanguage?.code)
                ? (page?.translations | dashboardTranslate: 'title':selectedLanguage?.code)
                : 'Untitled page'
            }}</label
          >
        </div>
        <mat-icon
          class="informative-pages-list-delete"
          #tooltip="matTooltip"
          color="primary"
          matTooltip="Remove this page"
          matTooltipPosition="above"
          (click)="onDelete(page)"
          >delete
        </mat-icon>
      </div>
    </div>
    <div class="informative-pages-empty" *ngIf="!thanksPages?.length"></div>
  </div>
  <button
    [ngStyle]="{ top: selectedStudy?.type !== StudyType.TIIM ? '2%' : 'none' }"
    class="informative-pages-btn"
    mat-fab
    color="accent"
    (click)="toggleSinglePageVisibility()"
  >
    <mat-icon>add</mat-icon>
  </button>
</div>

<div class="informative-page" *ngIf="isSinglePageVisible">
  <div class="informative-page-title" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon class="informative-page-title-arrow" (click)="onBack(); toggleSinglePageVisibility()"
      >arrow_back
    </mat-icon>
    <label class="informative-page-title-label">
      {{
        (selectedInformativePage?.translations | dashboardTranslate: 'title':selectedLanguage?.code)
          ? (selectedInformativePage?.translations | dashboardTranslate: 'title':selectedLanguage?.code)
          : 'Untitled page'
      }}
    </label>
  </div>
  <dashboard-informative-page
    (valueChange)="afterSave()"
    [supportedLanguages]="supportedLanguages"
    [selectedLanguage]="selectedLanguage"
  >
  </dashboard-informative-page>
</div>
